var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.computedClass }, [
    _vm.label
      ? _c(
          "span",
          { staticClass: "jade-display-item__label" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  color: "current-color",
                  variant: "text-small",
                  weight: "medium",
                },
              },
              [_vm._v(" " + _vm._s(_vm.label) + " ")]
            ),
            _vm.$slots.tooltip ? _vm._t("tooltip") : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _c(
      "span",
      { staticClass: "jade-display-item__content" },
      [
        _vm.isStatus
          ? _c(
              "jade-tag",
              {
                attrs: {
                  size: "medium",
                  solid: _vm.value?.solid,
                  variant: _vm.value?.variant,
                },
              },
              [_vm._v(" " + _vm._s(_vm.value.text) + " ")]
            )
          : _c(
              "jade-text",
              { attrs: { color: "current-color", variant: "display-small" } },
              [_vm._v(" " + _vm._s(_vm.value) + " ")]
            ),
      ],
      1
    ),
    _vm.support
      ? _c(
          "span",
          { staticClass: "jade-display-item__support" },
          [
            _c(
              "jade-text",
              {
                attrs: {
                  color: "current-color",
                  variant: "text-small",
                  weight: "regular",
                },
              },
              [_vm._v(" " + _vm._s(_vm.support) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }